// extracted by mini-css-extract-plugin
export default {"dashboard":"styles_dashboard__XhB3T","flex":"styles_flex__AXCnQ"};